// extracted by mini-css-extract-plugin
export var CTAsGrid = "CTAsSection-module--CTAsGrid--Ec-6M";
export var CTAsGridItem = "CTAsSection-module--CTAsGridItem--h19Pn";